export const getQueryParams = (params) => Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

export default { getQueryParams }
